/**
 * Whether a URL points somewhere the hosted Lens server cannot reach, so the
 * desktop app defaults to running it on this machine. Only a default — the
 * user can flip the toggle; the server's SSRF guard stays the real boundary.
 * No imports: `node --test` runs this file directly.
 */
export function isLikelyPrivateTarget(rawUrl: string): boolean {
  let host: string
  try {
    host = new URL(rawUrl.trim()).hostname.toLowerCase()
  } catch {
    return false
  }
  if (host.startsWith('[') && host.endsWith(']')) host = host.slice(1, -1)
  if (host === 'localhost' || host === '::1' || host.endsWith('.local')) return true
  const v4 = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/.exec(host)
  if (!v4) return false
  const a = Number(v4[1])
  const b = Number(v4[2])
  return a === 127 || a === 10 || (a === 172 && b >= 16 && b <= 31) || (a === 192 && b === 168)
}
